<div class="loader" *ngIf="loaderservice.isDisplay">
  <p>
    Trwa wczytywanie zapisywanie ...
  </p>
</div>
